import { Component, signal, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-filtros-reporte',
  imports: [],
  templateUrl: './filtros-reporte.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './filtros-reporte.css',
})
export class FiltrosReporte {
  mostrarFiltros = signal<boolean>(true);
  toggleFiltros() {
    this.mostrarFiltros.update((valor) => !valor);
  }
}
